import { Nullable } from "common/types";
import { Map } from "immutable";
import React from "react";

export type FormContextRootPath = (string | number)[];

/**
 * A field validator subscribed through `useValidate`. `rootRecord` is optional because `Form` skips
 * two-argument validators when the root record is absent, and because `DatePickerProps.validate`
 * already declares it optional — a validator must not assume the record is present.
 */
export type ValidateFunction = (value: any, rootRecord?: any) => Nullable<string>;
export interface FormContextEvent {
  rootPath: FormContextRootPath;
  name: string;
  value: any;
  validate: number;
}
export interface FormContextProps {
  errors: Map<string, string>;
  rootPath: FormContextRootPath;
  updateFormReducer: any;
  validationSubscriptions: Map<string, ValidateFunction>;
  addValidate: (name: string, validate: ValidateFunction) => void;
  removeValidate: (name: string) => void;
}

const defaultFormContext: FormContextProps = {
  errors: Map(),
  rootPath: [],
  updateFormReducer: null,
  validationSubscriptions: Map(),
  addValidate: () => {},
  removeValidate: () => {},
};

export const FormContext = React.createContext(defaultFormContext);
